<template>
<div>
    <div class="dekstop-view">
        <div class="tableFixHead sticky2">
            <table>
                <thead>
                    <tr>
                        <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index" :style="loadStyle(index)">
                            <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                            <span v-if="item == 'Action'" style="float:right">{{item}}</span>
                            <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(body, id) in data" :key="id">
                                    <td v-for="(item, index) in td" :key="index" :style="loadStyle(index)">
                                        <template v-if="item != 'action'">
                                            <template v-if="item == 'tanggal'">
                                                {{separator(body.tglMulai)}} - {{separator(body.tglSelesai)}}
                                            </template>
                                            <template v-else>
                                                <template v-if="item == 'tglCreated'">
                                                    {{separator(body[item])}}
                                                </template>
                                                <template v-else>
                                                    <template v-if="item == 'tampilkan'">
                                                        <span v-if="body[item] == 'Y'" class="badge bg-success">Tampil</span>
                                                        <span v-if="body[item] == 'N'" class="badge bg-secondary">Tidak Tampil</span>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="item == 'pesan'">
                                                            <span v-if="data[id].pesan == 'null'" :title="body['html']">{{body['html']}}</span>
                                                            <span v-else :title="body['pesan']">{{body['pesan']}}</span>
                                                        </template>
                                                        <template v-else>
                                                            <span :title="body[item]">{{body[item]}}</span>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                            
                                        </template>
                                        <template v-if="item == 'action'">
                                            <CButton @click="goEdit(id)" class="btn btn-edit">Edit</CButton>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div class="mobile-view">
        <CRow class="mt-3">
            <CCol sm="12">
                <div>
                    <table class="table-responsive">
                        <thead>
                            <tr>
                                <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index">
                                    <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                                    <span v-if="item == 'Action'" style="float:right">{{item}}</span>
                                    <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length == 0">
                            <tr>
                                <td class="text-center" colspan="5">
                                    {{errors}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(body, id) in data" :key="id">
                                <td v-for="(item, index) in td" :key="index">
                                    <template v-if="item != 'action'">
                                        <template v-if="item == 'tanggal'">
                                            {{separator(body.tglMulai)}} - {{separator(body.tglSelesai)}}
                                        </template>
                                        <template v-else>
                                            <template v-if="item == 'tglCreated'">
                                                {{separator(body[item])}}
                                            </template>
                                            <template v-else>
                                                <template v-if="item == 'tampilkan'">
                                                    <span v-if="body[item] == 'Y'" class="badge bg-success">Tampil</span>
                                                    <span v-if="body[item] == 'N'" class="badge bg-secondary">Tidak Tampil</span>
                                                </template>
                                                <template v-else>
                                                    <template v-if="item == 'pesan'">
                                                        <span v-if="data[id].pesan == 'null'" :title="body['html']">{{body['html']}}</span>
                                                        <span v-else :title="body['pesan']">{{body['pesan']}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <span :title="body[item]">{{body[item]}}</span>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                        
                                    </template>
                                    <template v-if="item == 'action'">
                                        <CButton @click="goEdit(id)" class="btn btn-edit">Edit</CButton>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
export default {
    props: ['data', 'th', 'td', 'styleTable', 'errors'],
    data() {
        return {
            sortIcon: [],
            photo: require('@/assets/image/images.svg'),
        }
    },
    mounted() {
        this.iconLoad('unsort', 'none')
    },
    watch: {
    },
    methods: {
        clickThead(index) {
            this.$emit('sort', index)
            this.iconLoad('sort', index)
        },
        goEdit(id) {
            this.$emit('edit', id)
        },
        loadStyle(index) {
            return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index]
        },
        iconLoad(type, index) {
            this.sortIcon = []
            let length = this.th.length
            var i = 0
            if (type == 'sort') {
                for(i=0;i<length;i++) {
                    let onPush = ''
                    if(index == i) {
                        onPush = require('../assets/menu/sort_normal.svg')
                    } else {
                        onPush = require('../assets/menu/sort_active.svg')
                    }
                    this.sortIcon.push(onPush)
                }
            } else {
                for(i=0;i<length;i++) {
                    let onPush = require('../assets/menu/sort_active.svg')
                    this.sortIcon.push(onPush)
                }
            }
        },
        separator(val) {
            let bulan = val.split("-")[1]
            let month = ''
            if(bulan == "01" || bulan == '1' || bulan == 1) {
                month = 'Jan'
            } else if(bulan == "02" || bulan == '2' || bulan == 2) {
                month = 'Feb'
            } else if(bulan == "03" || bulan == '3' || bulan == 3) {
                month = 'Mar'
            } else if(bulan == "04" || bulan == '4' || bulan == 4) {
                month = 'Apr'
            } else if(bulan == "05" || bulan == '5' || bulan == 5) {
                month = 'Mei'
            } else if(bulan == "06" || bulan == '6' || bulan == 6) {
                month = 'Jun'
            } else if(bulan == "07" || bulan == '7' || bulan == 7) {
                month = 'Jul'
            } else if(bulan == "08" || bulan == '8' || bulan == 8) {
                month = 'Ags'
            } else if(bulan == "09" || bulan == '9' || bulan == 9) {
                month = 'Sep'
            } else if(bulan == "10" || bulan == 10) {
                month = 'Okt'
            } else if(bulan == "11" || bulan == 11) {
                month = 'Nov'
            } else if(bulan == "12" || bulan == 12) {
                month = 'Des'
            }
            return val.split("-")[2] + ' ' + month + ' ' + val.split("-")[0]
        }
    },
}
</script>

<style scoped>
@media only screen and (max-width:1278px) {
  .dekstop-view {
      display: none;
  }
}
@media only screen and (min-width:1279px) {
  .mobile-view {
      display: none;
  }
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
</style>